import React from "react";
import { Controller } from "react-hook-form";
import FormLabel from "../../shared/components/ui/FormLabel";
import Checkbox from "../../shared/components/ui/Checkbox";
import Button from "../../shared/components/ui/Button";
import { Box } from "../../shared/components/ui/chakra";
import useSearchForm from "../lib/useSearchForm";

import { CheckboxGroup, Flex, PopoverCloseButton, Stack, Text } from "@chakra-ui/react";

const DetailSearchForm = ({
  tags,
  methods: { control }
}: {
  tags: Array<{ id: number; name: string }>;
  methods: Pick<ReturnType<typeof useSearchForm>, "control">;
}) => {
  return (
    <Box backgroundColor="#FFF">
      <Stack gap={6}>
        <Flex justifyContent={"space-between"}>
          <Text fontWeight={"bold"}>詳細検索</Text>
          <PopoverCloseButton
            position="relative"
            w="fit-content"
            p={0}
            _hover={{ background: "none" }}
          >
            <Box as="button" fontSize="sm" color="primary" type="button">
              閉じる
            </Box>
          </PopoverCloseButton>
        </Flex>
        <Box>
          <FormLabel>タグ</FormLabel>
          <Flex columnGap={4} rowGap={3} wrap="wrap" mt={1}>
            <Controller
              name="tags"
              control={control}
              render={({ field: { ref, ...field } }) => (
                <CheckboxGroup {...field}>
                  {tags.map(({ id, name }) => (
                    <Checkbox key={id} value={id.toString()} ref={ref}>
                      {name}
                    </Checkbox>
                  ))}
                </CheckboxGroup>
              )}
            />
          </Flex>
        </Box>
        <Controller
          name="only_bookmarked"
          control={control}
          render={({ field }) => (
            <Box>
              <FormLabel>ブックマーク</FormLabel>
              <Box mt={1}>
                <Checkbox
                  isChecked={field.value === "1"}
                  onChange={(e) => {
                    field.onChange(e.target.checked ? "1" : "0");
                  }}
                >
                  ブックマーク済みの投稿のみ表示
                </Checkbox>
              </Box>
            </Box>
          )}
        />
      </Stack>
      <Flex justify="flex-end" mt={4}>
        <Button type="submit" size="sm">
          <Text pt={0.5}>入力内容で検索</Text>
        </Button>
      </Flex>
    </Box>
  );
};

export default DetailSearchForm;
